import { render } from "./nav_panel.vue?vue&type=template&id=5ce78142"
import script from "./nav_panel.js?vue&type=script&lang=js"
export * from "./nav_panel.js?vue&type=script&lang=js"

import "./nav_panel.vue?vue&type=style&index=0&id=5ce78142&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__